import { Button, strIsNullOrEmpty } from '@fox/atoms';
import React from 'react';
import { useContentContext } from '../../content-context';
import { MemberShipFormTemplate } from '../membership-form-template';
import { MembershipFormFieldTypes } from '../membership-form-template/contracts';
import { redirect } from '../membership-form-template/util';
import { IRequestPasswordResetFormProps, RequestPasswordResetFormModel } from './contracts';
import { passwordResetValidationSchema } from './validation-schema';

export const RequestPasswordResetForm: React.FC<IRequestPasswordResetFormProps> = ({
	membershipFieldDisplayName,
	redirectUrl,
	loginUrl,
	blockContentAbsoluteUri
}) => {
	const { contentId, requestToken } = useContentContext();
	return (
		<>
			<MemberShipFormTemplate<RequestPasswordResetFormModel>
				contentId={contentId}
				recaptcha="memberRequestPasswordReset"
				submitButtonText="Reset password"
				validationSchema={passwordResetValidationSchema}
				initialValues={{
					blockContentAbsoluteUri,
					email: '',
					membershipFieldValue: ''
				}}
				submitFunction={async values => {
					return await fetch('/Umbraco/Api/Membership/SubmitMemberPasswordResetRequest', {
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
							RequestVerificationToken: requestToken
						},
						body: JSON.stringify({ ...values, contentId })
					});
				}}
				onSuccessFullSubmit={() => {
					if (redirectUrl?.url) {
						redirect(redirectUrl);
					}
				}}
				fields={[
					{
						name: 'email',
						label: 'Email address',
						fieldType: MembershipFormFieldTypes.TextField
					},
					{
						name: 'membershipFieldValue',
						label: membershipFieldDisplayName,
						fieldType: MembershipFormFieldTypes.TextField
					}
				]}
			/>
			{!strIsNullOrEmpty(loginUrl?.url) ? (
				<Button
					sx={{ width: '100%' }}
					variant="secondary"
					onClick={() => {
						redirect(loginUrl);
					}}
				>
					Return to log in
				</Button>
			) : null}
		</>
	);
};
